import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AdminRoutes from "./AdminRoutes";
import UserRoutes from "./UserRoutes";

const MainRoutes = () => {
  const isAdminRoute = window.location.pathname.includes("admin");
  return (
    <Router>
      <Routes>
        {/* Admin Routes */}
        {isAdminRoute && <Route path="/*" element={<AdminRoutes />} />}

        {/* User Routes */}
        {!isAdminRoute && <Route path="/*" element={<UserRoutes />} />}
      </Routes>
    </Router>
  );
};
export default MainRoutes;
